import { render, staticRenderFns } from "./IconASC.vue?vue&type=template&id=df6f5678&scoped=true&"
import script from "./IconASC.vue?vue&type=script&lang=ts&"
export * from "./IconASC.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df6f5678",
  null
  
)

export default component.exports